module.exports = __webpack_public_path__ + "img/arrow-big-white.f10f0fa0.svg";